/*
 * @@Author: MuYang
 */

import {isUndefined, assign} from 'lodash-es'
import {projectInfo} from '../../../utils'
import response from '../../../utils/response'
import authApi from './api'

//存储所有权限
const catchAuthMap = {}
// 不需要控权项目
const NO_AUTH = ['sur', 'mall']

// 获取权限 
export async function getBatchAuths (requestParams, objectApiNameMap) {
  if (NO_AUTH.includes(projectInfo.query())) {
    return true
  }
  const authMap = await _getBatchAuths(requestParams, objectApiNameMap)
  // 合并权限
  assign(catchAuthMap, authMap)
}

// 获取某个单一权限
export function findObjectAuthCode (pro, code) {
  if (NO_AUTH.includes(projectInfo.query())) {
    return true
  }
  return isUndefined(code) ? catchAuthMap[pro] : catchAuthMap[pro]?.[code]
}

// 是否有权限
export function isAuth (pro, code) {
  return isUndefined(code)
    ? !isUndefined(catchAuthMap[pro])
    : isUndefined(catchAuthMap[pro]?.[code])
}

// 批量查询权限接口
async function _getBatchAuths (authList, objectApiNameMap) {
  if (!authList.length) {
    return
  }
  // $https(authApi.type, authApi.url, authList)
  const res = await response({
    method: authApi.type,
    url: authApi.url,
    params: authList
  })
  const authMap = res.content
  const result = {}
  if (res.isOk && authMap) {
    for (let key in authMap) {
      if (!authMap.hasOwnProperty(key)) {
        continue
      }
      let permission = authMap[key]?.rs || []
      let _permission = {}
      for (let i = 0; i < permission.length; i++) {
        let auth = permission[i]
        if (auth.code !== '') {
          _permission[auth.code] = auth
        }
      }
      const _key = objectApiNameMap[key] || key
      result[_key] = _permission
    }
  }
  return result
}
